module.exports = "mutation SendPausedRecipients($recipientIds: [ID!]) {\n  sendPausedRecipients(recipientIds: $recipientIds) {\n    success\n  }\n}\n"